import logo from '../../assets/imgs/logo_nectar.png';
import img_st_11 from '../../assets/imgs/img_st_11.png';
import Navbar from './Navbar.js';

function HeroSec({title}) {
    return (
        <header className='flex justify-center relative'>
            <img src={img_st_11} className="absolute w-full h-full z-0 user-select" style={{ objectFit: 'cover' }} alt='logo' />
            <div className='max-w-8xl flex items-center justify-center relative w-full pt-2 pb-20 px-5 lg:px-24'>
                <div className='z-10 w-full h-full'>
                    <button data-collapse-toggle="navbar-default" type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-white rounded-lg md:hidden" aria-controls="navbar-default" aria-expanded="false">
                        <span className="sr-only">Open main menu</span>
                        <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                            <path fill='#FFF' stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15" />
                        </svg>
                    </button>

                    <div className='flex items-center justify-center mt-8'>
                        <img src={logo} alt="logo" className='w-20' />
                    </div>

                    <Navbar />

                    <div className='flex justify-center w-full mt-8'>
                        <h2 className='text-4xl uppercase text-white border gradient-border-b pb-1 mt-14 px-4'>{title}</h2>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default HeroSec;